
const backend_url = {
    prod: "https://partners.myginne.com",
    stag: "https://uat.myginne.com",
    local: "",
  };
  export var BASE_URL = backend_url.prod;
  